(() => {
  document.querySelectorAll('.lohriz-product-faq').forEach(root => {
    if (root.dataset.motionBound) return;
    root.dataset.motionBound = 'true';
    const entries = Array.from(root.querySelectorAll('details')).map(details => ({
      details, summary: details.querySelector('summary'), content: details.querySelector('summary + div'), wanted: details.open, animation: null
    }));
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const syncContent = entry => {
      if (entry.content) entry.content.inert = !entry.wanted;
    };
    const finish = entry => {
      const animation = entry.animation;
      entry.animation = null;
      if (animation) { animation.onfinish = null; animation.cancel(); }
      entry.details.open = entry.wanted;
      syncContent(entry);
      entry.details.style.height = '';
      entry.details.style.overflow = '';
      entry.summary.setAttribute('aria-expanded', String(entry.wanted));
    };
    const change = (entry, open) => {
      const {details, summary} = entry;
      const start = details.getBoundingClientRect().height;
      entry.wanted = open;
      if (entry.animation) { entry.animation.onfinish = null; entry.animation.cancel(); entry.animation = null; }
      if (!open && details.contains(document.activeElement) && document.activeElement !== summary) summary.focus({preventScroll:true});
      syncContent(entry);
      summary.setAttribute('aria-expanded', String(open));
      if (reduced.matches || typeof details.animate !== 'function') { finish(entry); return; }
      // Measure the natural endpoint before keeping content visible for closing.
      details.style.height = '';
      details.open = open;
      const end = details.getBoundingClientRect().height;
      details.open = true;
      details.style.overflow = 'hidden';
      const animation = details.animate([{height: `${start}px`}, {height: `${end}px`}], {duration:300, easing:'ease-in-out'});
      entry.animation = animation;
      animation.onfinish = () => { if (entry.animation === animation) finish(entry); };
    };
    entries.forEach(entry => {
      // JS coordinates animated closing; native grouping remains when JS is unavailable.
      entry.details.removeAttribute('name');
      syncContent(entry);
      entry.summary.setAttribute('aria-expanded', String(entry.wanted));
      entry.summary.addEventListener('click', event => {
        event.preventDefault();
        const open = !entry.wanted;
        if (open) entries.forEach(other => { if (other !== entry && other.wanted) change(other, false); });
        change(entry, open);
      });
    });
    const settle = () => entries.forEach(finish);
    window.addEventListener('resize', settle);
    if (reduced.addEventListener) reduced.addEventListener('change', settle);
  });
})();
